import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { SceneStore } from '@os/doc';
import { CANVAS_UI } from '../editor/canvas-ui';

/** In-place editing of the text on a connector, centred on its midpoint (world coordinates, constant screen size). */
export function ConnectorLabelEditor({ store, id, onDone }: { store: SceneStore; id: string; onDone: () => void }) {
  const { t } = useTranslation();
  const [initial] = useState(() => {
    const o = store.getObject(id);
    return o?.type === 'connector' ? (o.label ?? '') : '';
  });
  const mid = store.graph().paths.get(id)?.mid;
  if (!mid) return null;
  let done = false;
  const finish = (value: string | null) => {
    if (done) return;
    done = true;
    if (value !== null && value !== initial && !store.readOnly) store.commands.setProps([id], { label: value });
    onDone();
  };
  return (
    <div
      className="absolute left-0 top-0 origin-top-left"
      style={{ transform: `translate(${mid.x}px, ${mid.y}px) scale(var(--inv-zoom, 1)) translate(-50%, -50%)` }}
      {...{ [CANVAS_UI]: '' }}
      onPointerDown={(e) => e.stopPropagation()}
    >
      <input
        autoFocus
        aria-label={t('editor.connectorLabel')}
        defaultValue={initial}
        maxLength={200}
        onBlur={(e) => finish(e.currentTarget.value)}
        onKeyDown={(e) => {
          e.stopPropagation();
          if (e.key === 'Enter') finish(e.currentTarget.value);
          else if (e.key === 'Escape') finish(null);
        }}
        className="w-48 rounded-md border border-accent bg-white px-1.5 py-0.5 font-sans text-xs text-[#141414] outline-none"
      />
    </div>
  );
}
